import ServiceFetch from '../../../utilities/ServiceFetch.js';

/**
 * This service handles NIF authentication.
 */
export default class NifAuthenticationService {
	private readonly endpoint: string;

	constructor(options: { endpoint: string }) {
		this.endpoint = options.endpoint;
	}

	/**
	 * Authenticates the user.
	 *
	 * @returns Promise.
	 */
	public async authenticate(): Promise<void> {
		await ServiceFetch.text(`${this.endpoint}/context`, {
			method: 'GET',
			headers: {
				Accept: 'application/json'
			},
			credentials: 'include'
		});
	}
}
